<template>
  <div class="relative z-10" role="dialog" aria-modal="true">
    <ModalOverlay />
    <div class="fixed z-30 inset-0 overflow-y-auto">
      <div
        class="
          flex
          items-center
          justify-center
          min-h-screen
          h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:p-0
        "
      >
        <div
          v-click-outside="handleClickOutsideEvent"
          class="
            relative
            bg-primary
            rounded-lg
            text-left
            overflow-hidden
            shadow-xl
            transform
            transition-all
            sm:my-8 sm:align-middle w-full sm:max-w-lg
          "
        >
          <div class="bg-primary px-3 pt-3 pb-2 sm:p-4 sm:pb-2">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                <div class="flex w-full items-center justify-between">
                  <slot name="header"></slot>
                  <button
                    @click="handleCloseButtonClick"
                    class="
                      text-secondary
                      hover:bg-black
                      p-1
                      rounded-lg
                      transition-default
                    "
                  >
                    <CloseIcon class="w-6 h-6" />
                  </button>
                </div>

                <div class="mt-2">
                  <slot name="content"></slot>
                </div>
              </div>
            </div>
          </div>
          <div class="px-3 py-3 sm:px-4 flex items-center justify-end">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalOverlay from "./ModalOverlay.vue";
import CloseIcon from "@/components/icons/CloseIcon";
import vClickOutside from "click-outside-vue3";
export default {
  name: "SmallModal",
  components: {
    ModalOverlay,
    CloseIcon,
  },
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCloseButtonClick() {
      this.$emit("close");
    },
    handleClickOutsideEvent() {
      if (!this.persistent) {
        this.$emit("close");
      }
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style>
</style>